import {Component} from '@angular/core';

@Component({
    selector: 'tfl-fee-transfer-icon',
    template: require('./fee.html')
})
export class FeeTransferIcon {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/icons/fee/fee.transfer.icon.ts